$(function(){
    // Adds the file name to the file input overlay
    $('.file-input').on("change", function() {
        //Gets the file name
        var filename = $(this).val().split('\\').pop();
        //Sets the filename in the overlay so its visible
        $(this).closest('.file-label').find('.file-name').html(filename);
    });
});